
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/camps/ufabet",
      function () {
        return require("private-next-pages/camps/ufabet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/camps/ufabet"])
      });
    }
  